import { render } from "./CoursesDashboard.vue?vue&type=template&id=b560d96e"
import script from "./CoursesDashboard.vue?vue&type=script&lang=js"
export * from "./CoursesDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/historedez-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__